import { Col, Row, type RowProps } from 'antd';
import type { FunctionComponent, MouseEventHandler, ReactNode, SVGProps } from 'react';
import SvgConverter from '../../components/Common/SvgConverter';

interface FooterContentCardProps {
  count?: number | string | ReactNode;
  label: ReactNode;
  contentClass?: string;
  labelClass?: string;
  Icon?: FunctionComponent<SVGProps<SVGSVGElement>>;
  reverse?: boolean;
  align?: RowProps['align'];
  onClick?: MouseEventHandler<HTMLDivElement>;
  active?: boolean;
  className?: string;
  color?: string;
  textColor?: string;
  defaultValue?: number;
  dataTestId?: string;
  justify?: RowProps['justify'];
}

const FooterContentCard = ({
  count,
  label,
  contentClass = '',
  labelClass = '',
  Icon,
  reverse = false,
  align,
  onClick,
  active = false,
  className = '',
  color = '',
  textColor = '',
  defaultValue,
  dataTestId,
  justify = 'center',
}: FooterContentCardProps) => {
  return (
    <div
      className={`card-container ${className} ${onClick ? 'cursor-pointer' : ''} ${active ? 'active' : ''}`}
      {...(onClick ? { onClick } : {})}
      data-testid={dataTestId}
    >
      <Row gutter={5} justify={justify} align="middle">
        {Icon && (
          <Col>
            <SvgConverter Icon={Icon} color={active ? 'info' : color || 'white'} />
          </Col>
        )}
        <Col>
          <Row className={`${reverse ? 'flex-direction-column-reverse' : 'flex-direction-column'}`} align={align}>
            <Col>
              {/* biome-ignore lint/a11y/noLabelWithoutControl: <explanation> */}
              <label
                className={`${
                  active ? 'info' : textColor || 'white'
                } card-label ${onClick ? 'cursor-pointer' : ''} ${labelClass}`}
              >
                {label}
              </label>
            </Col>
            <Col>
              {/* biome-ignore lint/a11y/noLabelWithoutControl: <explanation> */}
              <label
                className={`${active ? 'info' : textColor || 'white'} card-count ${
                  onClick ? 'cursor-pointer' : ''
                } ${contentClass}`}
              >
                {count ? count : defaultValue}
              </label>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default FooterContentCard;
